import HighlightedValueStyle from "./HighlightedValue.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import { IHighlightedValueParams } from "./IHighlightedValueParams";

@observer
export class HighlightedValue extends React.Component<IHighlightedValueParams>{
    constructor(props: IHighlightedValueParams) {
        super(props, undefined);
    }

    formatEstimatedHandicap(score: number | undefined) {
        if (!score)
            return "";

        if (score < 42)
            return "36 or above"; // “Your Hcp is estimated to 36 or above”;

        if (score > 84)
            return "+5 or better"; // “Your Hcp is estimated to + 5 or below”;

        var hcp = Math.round((-0.0007 * (Math.pow(score, 3))) + (0.1447 * (Math.pow(score, 2))) - (10.513 * score) + 272.23);
        if (hcp > 0)
            return hcp.toString();
        else
            return "+" + Math.abs(hcp).toString();
    }

    render() {
        return <div className={this.props.className}>
            <div className={HighlightedValueStyle.combineHandicapBox}>
                       <p className={HighlightedValueStyle.score}>{this.formatEstimatedHandicap(this.props.estimatedHandicap)}</p>
                <p className={HighlightedValueStyle.estimatedHandicapDescription}>Your estimated handicap was calculated according to your test results and based on thousands of test results from other players.</p>
                   </div>
               </div>;
    }
}
